const storageKeys = {
  route: 'route',
  createFirstCampaignFlow: 'createFirstCampaignFlow',
};

export default storageKeys;

